"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parserPostFixExpression = void 0;
const util_1 = require("../util");
const parserPostFixExpression = (BaseClass) => {
    const DerivedClass = class extends BaseClass {
        visitPostFixNotationExpression(ctx) {
            return this.visitPostFix(ctx.postFix());
        }
        visitPostFix(ctx) {
            const updateOp = ctx.PLUSPLUS() ? '++' : '--';
            return {
                type: 'UpdateExpression',
                operator: updateOp,
                argument: (0, util_1.tokenToIdentifierWrapper)(ctx._argument)
            };
        }
    };
    return DerivedClass;
};
exports.parserPostFixExpression = parserPostFixExpression;
//# sourceMappingURL=postFixParser.js.map